module.exports = __webpack_public_path__ + "static/media/logoMobileHeader-old.2b35ddc0.svg";